// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2zM0-","type":"styles_type__2e8rS","choices":"styles_choices__1wol9"};